import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BookingDetails.html?raw';
import dojoDateLocale from 'dojo/date/locale';
import on from 'dojo/on';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import DoctorList_Main from '../../DoctorList/DoctorList_Main';
import { ExtraHelpers, ToasterHelpers } from "../../../../more/Helpers";


interface DoctorList_ItemDetails {
    ID: string,
    projectName: string;
    venue: string;
    room: string;
    contributers: string;
    opus: string;
    bookingName: string;
    startTime: string;
    endTime: string;
    bookingLimitationCheck: boolean;
}

const enum DoctorList_AssignmentModes {
    "assignMe",
    "removeMe",
    "assignForeign",
    "removeForeign",
    "editNote"

}
class BookingDetails extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private itemData: DoctorList_ItemDetails = null;
    itemId: string = null;
    assignedEntities: any = null;

    areBookedDocsLoaded: boolean = false;
    areAvailableDocsLoaded: boolean = false;

    foundSelf: any = null;

    activeDocCount: number = 0;
    inactiveDocCount: number = 0;

    assignButtons: Array<{
        "buttonNode": HTMLElement,
        "rootNode": HTMLElement,
        "nameNode": HTMLElement,
        "iconNode": HTMLElement,
        "item": any
    }> = [];

    standbyTarget: any = null;
    genericDialog: MdsLax<InstanceType<typeof GenericDialog>> = null;

    titleNode: HTMLHeadingElement;
    subTitleNode: HTMLDivElement;
    locationContainer: HTMLDivElement;
    locationNode: HTMLDivElement;
    castContainer: HTMLDivElement;
    castNode: HTMLDivElement;
    workContainer: HTMLDivElement;
    workNode: HTMLDivElement;
    doctorListNode: HTMLDivElement;
    availableDoctorsContainer: HTMLDivElement;
    availableDoctorsNode: HTMLDivElement;
    leftContainer: HTMLDivElement;

    assignselfButton: HTMLButtonElement;
    assignButtonDUMMY: HTMLButtonElement;
    removeselfButton: HTMLButtonElement;

    DoclistMainWrapper: MdsLax<InstanceType<typeof DoctorList_Main>>;

    private _loadItemDetails(): void {
        let requestUrl = window.appRoot + "doctorlist/GetItemDetails";

        let data = {
            bookingID: this.itemId,

        }

        let requestParams = {
            'jsonData': JSON.stringify(data)
        };

        this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, this._applyItemData),
            lang.hitch(this, "_onLoadListValuesError"),
            false // sync
        );
    }

    setData(itemData: DoctorList_ItemDetails, bSuppressApply?: boolean): void {
        this.itemData = itemData;

        if (bSuppressApply === true) {
            return;
        }

        this._applyItemData(itemData);
    }

    private assignmentLimitationActive: boolean = false;

    private _applyItemData(itemData: DoctorList_ItemDetails): void{

        this.itemData = itemData;
        //console.log("Booking Details item data", this.itemData);


        let date_start = new Date(this.itemData.startTime);
        let date_end = new Date(this.itemData.endTime);

        let date_start_str = dojoDateLocale.format(date_start, { selector: 'date', datePattern: "dd.MM.yyyy HH:mm" });
        let date_end_str = dojoDateLocale.format(date_end, { selector: 'date', datePattern: "dd.MM.yyyy HH:mm" });

        this.assignmentLimitationActive = itemData.bookingLimitationCheck !== true;

        let projectname = this.itemData.projectName
        let venue = this.itemData.venue;
        let room = this.itemData.room;
        let contributers = this.itemData.contributers;
        let opus = this.itemData.opus;
        let bookingName = this.itemData.bookingName;

        // title
        //
        this.UiModder.domAttr.set(this.titleNode, "innerHTML", bookingName)

        //  subtitle
        //
        this.UiModder.domAttr.set(this.subTitleNode, "innerHTML", date_start_str + " - " + date_end_str + "<br><br>" + projectname);

        if (venue != "" || projectname != "") {
            this.UiModder.domAttr.set(this.locationNode, "innerHTML", venue + "<br>" + room);
        }
        else {
            this.UiModder.domStyle.set(this.locationContainer, "display", "none");
        }

        if (contributers != "") {
            this.UiModder.domAttr.set(this.castNode, "innerHTML", contributers);
        }
        else {
            this.UiModder.domStyle.set(this.castContainer, "display", "none");
        }

        if (opus != "") {
            this.UiModder.domAttr.set(this.workNode, "innerHTML", opus);
        }
        else {
            this.UiModder.domStyle.set(this.workContainer, "display", "none");
        }


    }

    private _getAssignmentEntityFromBookingAndDoctor(bookingID, doctorID): void{
        for (var i = 0; i < this.assignedEntities.length; i++) {
            var entity = this.assignedEntities[i];

            if (entity.ref_ev_booking.ID == bookingID && entity.ref_address.ID == doctorID) {
                // BINGO
                return entity;
            }
        }

        return null;
    }

    private _loadDoctors(): void{
        this.StandbyStart();
        this.areBookedDocsLoaded = false;

        var requestUrl = window.appRoot + "doctorlist/GetDoctorsOfEvent";
        var requestParams = {
            "jsonData": JSON.stringify({
                'bookingID': this.itemId
            })
        };

        //sicherstellen das tabulator geladen hat
        ExtraHelpers.sideLoadResource(window.appRoot + "Content/tabulator/js/tabulator.min.js", 'js').then(()=>{
            this.RequestManager.post(
                requestUrl,
                requestParams,
                lang.hitch(this, this._onLoadListValuesResponse),
                lang.hitch(this, this._onLoadListValuesError),
                false // sync
            );
        });
    }

     private _onLoadListValuesResponse(doctorListEntities): void{

        this.UiModder.domClass.remove(this.doctorListNode);

        this.assignedEntities = doctorListEntities;

        //console.log("assigned doctors - _onLoadListValuesResponse", doctorListEntities);
        if (doctorListEntities.length == 0) {
            this.UiModder.domAttr.set(this.doctorListNode, "innerHTML", "keine Ärzte zugeteilt");
            this.UiModder.domClass.add(this.doctorListNode, "w3-text-gray");
        }

        else {
            let table = new Tabulator(this.doctorListNode, {
                data: doctorListEntities,
                layout: "fitColumns",
                //height: "unset",
                selectable: false,
                columns: [
                    { title: this.translations["Doctorlist__Booking_UserList_ColTitle_Name"],/* "Arzt", */field: "ref_address.gDisp_1", width: 200, headerSort: true },
                    { title: this.translations["Doctorlist__Booking_UserList_ColTitle_IsActive"],/*"Aktiv", */width: 50, field: "is_active", formatter: "tickCross", headerSort: false },
                    //{ title: this.translations["Doctorlist__Booking_UserList_ColTitle_IsMarkedDeletion"],/*"Abmelden?",*/ width: 70, field: "is_marked_for_deleting", formatter: "tick", headerSort: false },
                    { title: this.translations["Doctorlist__Booking_UserList_ColTitle_Note"],/*"Anmerkung", */width: 200, field: "note", formatter: "textarea", headerSort: false },
                    { title: this.translations["Doctorlist__Booking_UserList_ColTitle_NoteSpecialization"],/*"Anmerkung", *//*width: 180,*/ field: "ref_address.note", headerSort: false, formatter: "textarea" }
                ],
                rowFormatter: function (row) {
                    let data = row.getData();

                    if (data.is_hidden === true) {
                        row.getElement().style.color = "#aaa";
                    }
                    let rowNode = row.getElement();

                    if (!data.is_active) {
                        rowNode.classList.add("inactive");
                    //    row.getElement().style.backgroundColor = "#FFDDDD";
                    //    row.getElement().style.opacity = "0.5";
                    } else if (data.is_marked_for_deleting) {
                        //row.getElement().style.backgroundColor = "#FFDD00";
                        rowNode.classList.add("markedForDeletion");
                    }
                },

            });

            table.setSort("is_active", "desc");
            //this.UiModder.domStyle.set(table.element, "fontSize", "0.8em");
            //table.clearSort();

            //table.setSort([ // funzt ned....
            //    { column: "is_active", dir: "desc" }, //sort by this first
            //    { column: "ref_address.gDisp_Name_Firstname", dir: "asc" }
            //]);
        }
        //console.log(doctorListEntities);


        var foundSelf = false;
        var i = 0;
        var inactiveEntities = 0;
        var activeEntities = 0;
        while (i < doctorListEntities.length) {
            //console.log(doctorListEntities[i].ref_address.ID + " - " + window.openSessionResult.CurrentEmployeeId);
            if (!doctorListEntities[i].is_active) {
                inactiveEntities++;
            } else {
                activeEntities++;
            }
            if (doctorListEntities[i].ref_address.ID == window.sessionInfo.getCurrentEmployeeId()) {
                this.foundSelf = doctorListEntities[i];
            }

            i++;
        }


        this.areBookedDocsLoaded = true;

        this.set("activeDocCount", activeEntities);

        this.tryEndStandby();
    }
    _onLoadListValuesError(error): void{
        this.areBookedDocsLoaded = true;

        this.DoclistMainWrapper.publishToastMessage("Error loading doctors of event", ToasterHelpers.ToasterIcons.error, 0, error.Message);

        this.tryEndStandby();
    }

    private _onClick_AssignMyself(evt: MouseEvent): void {
        //"bookingID": this.item.id, "targetUserID": window.openSessionResult.UserId
        if (this.activeDocCount > 0) {
            return;
        }

        if (this.assignmentLimitationActive == true) {
            let dlg = new GenericDialog();

            dlg._setHeaderAttr(this.itemData.bookingName);
            dlg._setContentAttr(this.translations["Doctorlist__Booking_AssignmentLimitationNotice"]);
            dlg._setCloseBtnAttr(false);
            dlg._setTopCloseBtnAttr(true);
            dlg._setOkBtnAttr(true);

            dlg.show();

            return;
        }

        let myAssignment = this.foundSelf;
        if (myAssignment != null) { // bin ja schon drauf??
            if (myAssignment.is_active) {
                return;
            }
        }

        let data = {
            "bookingID": this.itemId,
            "targetUserID": window.sessionInfo.sessionData.UserId,
            "doctorID": window.sessionInfo.sessionData.CurrentEmployeeId,
            "note": "",
            // für zuweisung-Dialog.
            "doctorName": window.sessionInfo.sessionData.UserDisplayName,
        };

        let callback = lang.hitch(this, this._assignDoctor, data);

        let mode = DoctorList_AssignmentModes.assignMe;

        this.showAssignmentNoteDialog(data, callback, mode);

    }

    private _assignDoctor(data): void {
        this.StandbyStart();
        var requestUrl = window.appRoot + "doctorlist/AddDoctorToBooking";
        var requestParams = {
            "jsonData": JSON.stringify(data)
            //'BookingID': this.item.id,
            //'DoctorID': window.openSessionResult.UserId
        };

        this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, this._onAssignDoctorResponse),
            lang.hitch(this, this._onAssignDoctorError),
            false // sync
        );

        //this.reload();
    }
    private _onAssignDoctorResponse(response): void {
        this.StandbyStop();
        this.reload();
        this.DoclistMainWrapper.mainProperties.loadData();
        //window.mainProperties.loadData(); // legacy aus JS

    }
    private _onAssignDoctorError(error): void{
        this.StandbyStop();
        alert(error.Message);
        console.error(error);
    }

    private _setActiveDocCountAttr(value): void{
        this.activeDocCount = value;

        this.setAssignButtonStyles();
    }

    private _onClick_RemoveMyself(evt: MouseEvent): void { // mich austragen
        var myAssignment = this.foundSelf; //._getAssignmentEntityFromBookingAndDoctor(this.item.id, window.openSessionResult.CurrentEmployeeId);

        if (myAssignment == null || myAssignment == false) { // kann ned sein, darf ned sein!
            return;
        }

        //console.log("_onClick_RemoveDoctor", myAssignment);

        let data = {
            "bookingID": this.itemId,
            "targetUserID": window.sessionInfo.sessionData.UserId,
            "assignmentID": myAssignment.ID,
            "doctorID": myAssignment.ref_address.ID,
            "note": myAssignment.note,
            // für dia Überschrift im Dialog:
            "doctorName": myAssignment.ref_address.gDisp_1,
        };

        var callback = lang.hitch(this, "_removeDoctor", data);

        let mode = DoctorList_AssignmentModes.removeMe;

        this.showAssignmentNoteDialog(data, callback, mode);
    }

    private _removeDoctor(data): void{

        var requestUrl = window.appRoot + "doctorlist/RemoveDoctorFromBooking";
        var requestParams = {
            jsonData: JSON.stringify(data)
            //'BookingID': this.item.id,
            //'EmployeeID': window.openSessionResult.CurrentEmployeeId
        };

        this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, "_onRemoveDoctorResponse"),
            lang.hitch(this, "_onRemoveDoctorError"),
            false // sync
        );

        //alert("Danke, dass Sie uns über Ihre Abmeldung informiert haben. Wir werden Ihren Namen sobald als möglich aus der betreffenden Veranstaltung entfernen.\n- Ihr Konzerthaus-Team");
        //var message = this.translations["Doctorlist__Booking_RemoveMeConfirmationMessage"].replace("<br/>", "\r\n");
        //if (typeof (message) != "undefined" && message != null && message != "") {
        //    //alert(message);
        //}

    }
    private _onRemoveDoctorResponse(result): void {
        this.reload();
        this.DoclistMainWrapper.mainProperties.loadData();
        //window.mainProperties.loadData();
    }
    private _onRemoveDoctorError(error): void {
        //this.reload();
        console.error(error);
    }

    private showAssignmentNoteDialog(itemData, callback, mode: DoctorList_AssignmentModes): void {

        // assignmentID
        // bookingID
        // doctorID
        // note

        var currentNote = itemData.note;
        var doctorName = itemData.doctorName;
        var bookingName = itemData.bookingName;

        var dialog = new GenericDialog();

        this.genericDialog = dialog;
        this.UiModder.domStyle.set(dialog.textNode, "height", "unset");


        var input = this.UiModder.domConstruct.create("textarea");
        this.UiModder.domClass.add(input, "w3-input w3-block");
        dialog.addNodeToContent(input);

        this.UiModder.domAttr.set(input, "placeholder", this.translations["Doctorlist__Booking_EditNoteDlg_Placeholder"]);//"Anmerkungen?");



        if (currentNote != null && currentNote != "") {
            this.UiModder.domAttr.set(input, "value", currentNote);
        }

        // verhinden dass mit "Enter" der Dialog beendet wird
        on(input, "keyup", function (evt) {
            evt.stopPropagation();
        });

        dialog.set("header", this.stringFormat(this.translations["Doctorlist__Booking_EditNoteDlg_Header"], doctorName, this.itemData.bookingName));

        // Untertitel abhängig von der Aktion
        var translationString = "Doctorlist__Booking_EditNoteDlg_Subtitle";
        switch (mode) {
            case DoctorList_AssignmentModes.assignMe:
                translationString = "Doctorlist__Booking_EditNoteDlg_Subtitle_AssignMe"; break;

            case DoctorList_AssignmentModes.removeMe:
                translationString = "Doctorlist__Booking_EditNoteDlg_Subtitle_RemoveMe"; break;

            case DoctorList_AssignmentModes.assignForeign:
                translationString = "Doctorlist__Booking_EditNoteDlg_Subtitle_AssignForeign"; break;

            case DoctorList_AssignmentModes.removeForeign:
                translationString = "Doctorlist__Booking_EditNoteDlg_Subtitle_RemoveForeign"; break;

            case DoctorList_AssignmentModes.editNote:
                translationString = "Doctorlist__Booking_EditNoteDlg_Subtitle_EditNote"; break;
        }


        dialog._setSubTitleAttr(this.translations[translationString]);
        //dialog.set("content", "Hier der Haupttext.");
        dialog._setCallbackAttr( lang.hitch(this, this.assignmentNoteDialogCallback, input, itemData, callback));

        dialog._setOkBtnAttr(true);
        dialog._setCancelBtnAttr(true);


        dialog.show();
    }

    private assignmentNoteDialogCallback(textinput, itemData, callback, dlgResult): void {
        //console.debug("assignmentNoteDialogCallback", dlgResult, textinput.value, itemData);
        if (dlgResult <= 0) // Abbruch oder Nein
        {
            return;
        }

        if (typeof (callback) != "undefined" || callback != null) {
            itemData.note = textinput.value;

            callback(itemData);
        }

        //
    }



    private _loadAvailableDoctors(): void {
        this.StandbyStart();
        this.areAvailableDocsLoaded = false;

        if (this.hasUserRole("ADMIN_DOC") == true ||
            this.hasUserRole("DOC-ADMIN") == true ) {
            this.UiModder.domStyle.set(this.availableDoctorsContainer, "display", "block");

            let requestUrl = window.appRoot + "doctorlist/GetPotentialDoctorsForBooking";

            let data = { 'bookingID': this.itemId };

            this.RequestManager.post(
                requestUrl,
                {
                    "jsonData": JSON.stringify(data),
                },
                lang.hitch(this, this._getAllDoctorsResponse),
                lang.hitch(this, this._getAllDoctorsError),
                false // sync
            );
        }
        else {
            this.areAvailableDocsLoaded = true;
            this.setAssignButtonStyles();
            this.UiModder.domStyle.set(this.availableDoctorsContainer, "display", "none");
            this.UiModder.domClass.remove(this.leftContainer, "l9");
        }
    }

    private prepareChangeDoctorAssignment(buttonItem, tUrl): void  {
        //console.log("prepareChangeDoctorAssignment", buttonItem, tUrl);
        let targetWebuserID = buttonItem.webUserID;
        let targetDoctorID = buttonItem.personID;
        let targetDoctorName = buttonItem.name;
        let bookingID = this.itemId
        let existingAssignmentID = "";
        if (typeof (buttonItem.assignmentID) != "undefined") {
            existingAssignmentID = buttonItem.assignmentID;
        }

        let data = {
            "bookingID": bookingID,
            "targetUserID": targetWebuserID,
            "assignmentID": existingAssignmentID,
            "doctorID": targetDoctorID,
            "note": buttonItem.assignmentNote,
            // für Überschrift im Dialog:
            "doctorName": targetDoctorName,
        };

        let callback = lang.hitch(this, "changeDoctorAssignment", data, tUrl);

        let mode = DoctorList_AssignmentModes.assignForeign;
        if (existingAssignmentID != "" && buttonItem.isAdded != 2) {
            mode = DoctorList_AssignmentModes.removeForeign;
        }

        this.showAssignmentNoteDialog(data, callback, mode);
    }

    private changeDoctorAssignment(data, tUrl): void {
        //console.log("changeDoctorAssignment", data, tUrl);

        let requestUrl = window.appRoot + tUrl;

        this.StandbyStart();

        //console.log(tUrl);
        this.RequestManager.post(
            requestUrl,
            {
                "jsonData": JSON.stringify(data)
                //'BookingID': booking,
                //'DoctorID': doctor
            },
            lang.hitch(this, this._onChangeDoctorAssignmentResponse),
            lang.hitch(this, this._onChangeDoctorAssignmentError),

            false // sync
        );
    }

    private _onChangeDoctorAssignmentResponse(response): void {

        //console.log("_onChangeDoctorAssignmentResponse", response);
        this.reload();
        //window.mainProperties.loadData();
        this.DoclistMainWrapper.mainProperties.loadData();
    }

    private _onChangeDoctorAssignmentError(error): void {
        console.error("_onChangeDoctorAssignmentError", error);
        this.StandbyStop();

        alert(error.Message);
    }

    private _getAllDoctorsResponse(response): void  {
        let i = 0;
        let Arr = response.Arr;

        this.assignButtons = [];

        while (i < Arr.length) {

            let item = Arr[i];

            let entryNode = this.UiModder.domConstruct.create("div", {
                style: {
                    //border: "1px solid " + borderColor,
                    //padding: "4px",
                    margin: "3px 0px",
                    //"justifyContent": "space-between",
                    "flex-wrap": "nowrap"
                },
                className: "flex_row_stretch entry"
            }, this.availableDoctorsNode);

            let nameContainer = this.UiModder.domConstruct.create("div", {
                //style: {

                //},
                className: "labels",
                //innerHTML: item.name,
            }, entryNode);

            let nameNode = this.UiModder.domConstruct.create("div", {
                innerHTML: item.name,
                className: "name",
            }, nameContainer);

            let professionNode = this.UiModder.domConstruct.create("div", {
                innerHTML: item.note,
                className: "description"
            }, nameContainer);


            let buttonNode = this.UiModder.domConstruct.create("div", {
                style: {
                    //'background-color': buttonColor,
                    color: "white",
                    'font-weight': "bold",
                    'text-align': "center",
                    //'padding-top': "4px",
                    //width: "30px",
                    //height: "20px",
                    //float: "right",
                    //cursor: "pointer",
                },
                className: "paddingSmall flex_row_center",
                //innerHTML: buttonSymbol,
            }, entryNode, "first");


            let iconNode = this.UiModder.domConstruct.create("i", {
                className: "fas"
            }, buttonNode);


            // den Button und seine Nodes merken, damit man später noch drauf zukommt
            this.assignButtons.push({
                "buttonNode": buttonNode,
                "rootNode": entryNode,
                "nameNode": nameNode,
                "iconNode": iconNode,
                "item": item
            });

            i++;
        }

        this.areAvailableDocsLoaded = true;

        this.setAssignButtonStyles();

        this.tryEndStandby();
    }
    private _getAllDoctorsError (error): void {
        console.error(error);

        this.areAvailableDocsLoaded = true;
        this.tryEndStandby();
    }

    private setAssignButtonStyles(): void {

        /*if (this.areAvailableDocsLoaded != true || this.areBookedDocsLoaded != true) {
            return;
        }*/

        // für ADMIN:

        // es gibt Kriterien wonach das Hinzufügen weiterer Ärzte nicht mehr zulässig ist
        // zB. wenns schon einen Arzt gibt der aktiv drauf ist

        let bEnable = true;

        //console.log("setAssignButtonStyles", this.assignButtons, this.activeDocCount);

        for (var i = 0; i < this.assignButtons.length; i++) {
            let buttonData = this.assignButtons[i];
            let item = buttonData.item;

            bEnable = true;

            let targetMode = item.isAdded != 1 ? "add" : "remove";
            if (this.activeDocCount > 0 && targetMode == "add") { // deaktivieren falls der Button zum Hinzufügen ist und es schon Ärzte gibt
                bEnable = false;
            }

            let targetUrl = targetMode == "add" ? "doctorlist/AddDoctorToBooking" : "doctorlist/RemoveDoctorFromBooking";

            //console.log("buttonStyle", item, buttonData.rootNode, targetUrl, bEnable, this.activeDocCount, targetMode);

            if (targetMode == "add") { // falls der Klick das Hinzufügen auslösen soll....


                this.UiModder.domClass.add(buttonData.iconNode, "fas fa-user-plus");//fa-chevron-left"); // "nach links" rüberschupfen

                if (item.isAdded == 2)// war schon mal dabei und ist wieder deaktiviert worden
                {
                    this.UiModder.domClass.add(buttonData.buttonNode, "w3-amber"); // Button wird gelb
                    this.UiModder.domClass.add(buttonData.rootNode, "w3-border-red");
                }

                else {
                    this.UiModder.domClass.add(buttonData.buttonNode, "w3-green"); // Button ist grün
                    this.UiModder.domClass.add(buttonData.rootNode, "w3-border-gray"); // Arzt ist noch nicht dabei, Rahmen ist grau
                }

            } else { // Arzt ist schon dabei
                this.UiModder.domClass.add(buttonData.iconNode, "fas fa-user-minus");//fa-chevron-right");
                this.UiModder.domClass.add(buttonData.buttonNode, "w3-red");
                this.UiModder.domClass.add(buttonData.rootNode, "w3-border-light-green");

            //    setTimeout(lang.hitch(this, function (node: HTMLElement) {
            //        node.scrollIntoView();
            //    }, buttonData.buttonNode), 1000);
            }

            if (bEnable === true) {
                this.UiModder.domClass.add(buttonData.buttonNode, "hoverBright");
                //on(buttonData.buttonNode, "click", function () { console.info("klick aktiv"); });
                on(buttonData.buttonNode, "click", lang.hitch(this, "prepareChangeDoctorAssignment", item, targetUrl));
            } else {
                this.UiModder.domClass.add(buttonData.rootNode, "w3-disabled");
                //on(buttonData.buttonNode, "click", function () { console.info("klick deaktiviert!"); });
            }
        }


        // für den Normalo-User
        let disableButton = false;

        /*if (this.foundSelf != null) {
            if (this.foundSelf.is_marked_for_deleting) {
                this.UiModder.domAttr.set(this.removeButton, "title", this.translations["Doctorlist__Booking_RemoveBtnTitle_AlreadyMarkedDeletion"]);// "Sie haben schon einen Abmeldungsrequest für diese Buchung gesendet.");
                var disableButton = true;
            }

            if (!this.foundSelf.is_active) {
                this.UiModder.domAttr.set(this.removeButton, "title", this.translations["Doctorlist__Booking_RemoveBtnTitle_AlreadyInactive"]);//"Sie wurden schon von dieser Buchung abgemeldet.");
                var disableButton = true;
            }

            if (disableButton) {
                this.UiModder.domAttr.set(this.removeButton, "disabled", "true");
                this.UiModder.domClass.remove(this.removeButton, "w3-red hoverBright");
                this.UiModder.domClass.add(this.removeButton, "w3-disabled w3-gray");
                //this.UiModder.domStyle.set(this.removeButton, "cursor", "default");
                //this.UiModder.domStyle.set(this.removeButton, "opacity", "0.5");
                this._onClick_RemoveDoctor = function () { };
            }
        }*/

        //console.log("setAssignButtonStyles", "foundself?", this.foundSelf, "activeDocs?", this.activeDocCount);

        if (this.foundSelf != null && this.foundSelf.is_active) {
            this.UiModder.domStyle.set(this.assignselfButton, "display", "none");
            this.UiModder.domStyle.set(this.removeselfButton, "display", "block");
        }
        else {
            this.UiModder.domStyle.set(this.assignselfButton, "display", "block");
            this.UiModder.domStyle.set(this.removeselfButton, "display", "none");

            if (this.activeDocCount > 0) {
                this.UiModder.domStyle.set(this.assignButtonDUMMY, "display", "block");
                this.UiModder.domStyle.set(this.assignselfButton, "display", "none");

            } else {
                this.UiModder.domStyle.set(this.assignButtonDUMMY, "display", "none");
                this.UiModder.domStyle.set(this.assignselfButton, "display", "block");
            }
        }

        //break;


    }

    reload(): void {
        this.UiModder.domAttr.set(this.doctorListNode, "innerHTML", "");
        this.UiModder.domAttr.set(this.availableDoctorsNode, "innerHTML", "");

        this._loadItemDetails();
        this._loadDoctors();
        this._loadAvailableDoctors();
    }

    private tryEndStandby(): void {
        if (this.areAvailableDocsLoaded && this.areBookedDocsLoaded) {
            this.StandbyStop();
        }
    }


    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this._standbyOverlay.target = this.standbyTarget; //??

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        //console.debug("BookingDetails startup", this.itemId);
        //this.setUrlParameter(DoctorList_UrlParameters.action, "item");
        //this.setUrlParameter(DoctorList_UrlParameters.item, this.itemId);

        this.reload();

    }


}

export default mdsWidget(BookingDetails);
